import React from 'react';
import { Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
const ClaimGroupSelector = _ref => {
  let {
    accountType,
    loading,
    company,
    claimGroup,
    allClaimGroups
  } = _ref;
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const handleClaimGroupChange = async e => {
    const selectedClaimGroupId = e.target.value;
    if (accountType === 'customer') {
      const hasDashboardAccess = user.user_accesses?.find(uA => uA.rollable_id === Number(selectedClaimGroupId) && uA.rollable_type === 'ClaimGroup')?.dashboard_access;
      if (hasDashboardAccess) {
        if (process.env.PUBLIC_URL !== '/be' && process.env.PUBLIC_URL !== '/de') {
          if (company.dashboard_type === 'business_unit_intensity_breakdown') {
            window.location.href = `/${accountType}/claim_groups/${selectedClaimGroupId}/regular_realtime_dashboard/${company.id}`;
            return;
          }
          return history.push(`/${accountType}/claim_groups/${selectedClaimGroupId}/dashboard/${company.id}`);
        } else if (process.env.PUBLIC_URL === '/de') {
          return history.push(`/${accountType}/claim_groups/${selectedClaimGroupId}/project_overview`);
        } else {
          return history.push(`/${accountType}/claim_groups/${selectedClaimGroupId}/claim_group_dashboard`);
        }
      }
      if (process.env.PUBLIC_URL === '/be') {
        return history.push(`/${accountType}/claim_groups/${selectedClaimGroupId}/claim_group_dashboard`);
      }
    }
    return history.push(`/${accountType}/companies/${company.id}/${selectedClaimGroupId}/master`);
  };
  const getClaimGroupOptions = () => {
    const sortedClaimGroupYears = allClaimGroups.sort((a, b) => a.name.slice(-4) > b.name.slice(-4) ? -1 : 1);
    return sortedClaimGroupYears.map(claimGroup => {
      return /*#__PURE__*/React.createElement("option", {
        value: claimGroup.id
      }, claimGroup.name.replace(company.name, '').trim());
    });
  };
  if (!claimGroup) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-2 my-3"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: claimGroup.id,
    onChange: handleClaimGroupChange,
    name: "current_claim_group",
    as: "select",
    size: "md",
    className: "p-1 "
  }, !loading && getClaimGroupOptions()));
};
export default ClaimGroupSelector;